import React, { useState } from 'react'
import Header from '@/components/Header'
import ConnectUs from '@/components/ConnectUs'
import Footer from '@/components/Footer'
import Customer from '@/components/Customer'
// import RightSideBar from '@/components/RightSideBar'
import Project from '@/components/Project'
import Company from '@/pages/index/components/Company'
import Banner from '@/pages/index/components/Banner'
import Practice from '@/pages/index/components/Practice'
import Platform from '@/pages/index/components/Platform'
import useScroll from '@/utils/hooks/useScroll'
// import useScrollTop from '@/utils/hooks/useScrollTop'
import styles from '@/pages/index/index.module.scss'

const Index = (props: any) => {
  const [isRender, setIsRender] = useState(false)
  const isScroll  = useScroll()
  return (
    <div className={styles['ignore-home-page']}>
      {/* <Header fixed={isScroll} />
      <Banner />
      <Company />
      <Project />
      <Platform />
      <Practice />
      <Customer />
      <ConnectUs />
      <Footer /> */}

      {/* <RightSideBar /> */}
    </div>
  )
}
export default Index
